import {Button, Input, Select} from 'antd';
import {useState} from 'react';
import {RoleType} from 'graphql/types/AccountType';
import { useTranslation } from 'react-i18next';
import InputFilterItem from '../../../delivery/components/InputFilterItem';
import { useFilterContainerClassName, useFilterLabelClassName, useFilterInputContainerClassName } from '../../../../utils/languageUtils';

export interface FilterOptions {
    role: RoleType | 'all';
    id: string;
    name: string;
    phone: string;
    status: number;
}

interface StatusOption {
    value: number;
    label: string;
}



interface FilterAreaProps {
    filters: FilterOptions;
    setFilters: (filters: FilterOptions) => void;
}



export const DEFAULT_FILTER_OPTIONS: FilterOptions = {
    role: 'all',
    id: '',
    name: '',
    phone: '',
    status: 2,
};

const FilterArea: React.FC<FilterAreaProps> = ({filters, setFilters}) => {
    const { t } = useTranslation();
    const containerClassName = useFilterContainerClassName();
    const labelClassName = useFilterLabelClassName();
    const inputContainerClassName = useFilterInputContainerClassName();
    const STATUS_OPTIONS: StatusOption[] = [
        {value: 2, label: t('enum.activeStatus.all')},
        {value: 1, label: t('enum.activeStatus.active')},
        {value: 0, label: t('enum.activeStatus.suspended')},
    ];

    const handleFilterChange = (name: string, value: any) => {
        setFilters({
            ...filters,
            [name]: value
        });
    };

    return (
        <div className="mb-2 py-2 pl-0">
            {/* 使用 Grid 布局确保列对齐 */}
            <div className="grid grid-cols-3 gap-x-10 gap-y-4 items-start">
                {/* 第一列 - 统一标签宽度 */}
                <div className="min-w-0">
                    <InputFilterItem
                        label={t('pickup.account.filters.personnelId')}
                        value={filters.id}
                        onChange={(e) => handleFilterChange('id', e.target.value)}
                        spanClassName="!w-[48px] !min-w-0 !flex-shrink-0"
                    />
                </div>
                {/* 第二列 - 统一标签宽度 */}
                <div className="min-w-0">
                    <InputFilterItem
                        label={t('pickup.account.filters.name')}
                        value={filters.name}
                        onChange={(e) => handleFilterChange('name', e.target.value)}
                        spanClassName="!w-[36px] !min-w-0 !flex-shrink-0"
                    />
                </div>
                {/* 第三列 - 统一标签宽度 */}
                <div className="min-w-0">
                    <InputFilterItem
                        label={t('pickup.account.filters.phone')}
                        value={filters.phone}
                        onChange={(e) => handleFilterChange('phone', e.target.value)}
                        spanClassName="!w-[48px] !min-w-0 !flex-shrink-0"
                    />
                </div>
                {/* 第二行第一列 - 统一标签宽度 */}
                <div className="min-w-0">
                    <div className={containerClassName}>
                        <span className={`${labelClassName} !w-[48px] !min-w-0 !flex-shrink-0`}>{t('pickup.account.filters.status')}</span>
                        <div className={inputContainerClassName}>
                            <Select
                                placeholder={t('components.input.all') || ''}
                                className="w-full"
                                size="middle"
                                options={STATUS_OPTIONS}
                                value={filters.status}
                                onChange={(value) => handleFilterChange('status', value)}
                            />
                        </div>
                    </div>
                </div>
                <div className="min-w-0"></div>
                <div className="min-w-0"></div>
            </div>
        </div>
    );
};

export default FilterArea;